export default function () {
    $('body').css('--vh', `${window.innerHeight * 0.01}px`);
}
// height: calc(var(--vh, 1) * 100)
